import React, { useState } from 'react'

import { Icon, Input } from '@st-operations/uikit/src/v2'

import CollapsibleSection from '_components/collapsible-section/index.jsx'
import { AVAILABLE_SLIDES, CATEGORIES } from './constants/availableSlides'
import thumbnails from './template/thumbnails'

import './AddSlidePane.scss'

const Slide = ({ slide, handleAddSlide }) => (
  <button
    key={slide.template}
    className="add-slide-pane__slide add-slide-pane__slide--grid"
    onClick={handleAddSlide}
  >
    <span className="add-slide-pane__slide-title">{slide.title}</span>
    <div className="add-slide-pane__image-wrapper">
      <img src={thumbnails[slide.template] ?? thumbnails.defaultImage} alt="" srcset="" />
      <Icon icon="plus2" type="fill" width={16} height={16} color="#13682B" />
    </div>
  </button>
)

// NOTE: this is the same function used in modal to select slides
const searchSlide = (search) => ({ category, tags, template, title }) => {
  if (!!search) {
    const textTokens = `${category} ${template} ${title} ${tags?.join(' ') ?? ''}`
      .replaceAll('_', ' ')
      .toLowerCase()
    return textTokens.includes(search.toLowerCase())
  }
  return true
}

const AddSlidePane = ({ onAddSlide }) => {
  const [search, setSearch] = useState('')

  const handleAddSlide = (slide) => () => {
    onAddSlide(slide)
  }

  return (
    <div className="add-slide-pane">
      <div className="add-slide-pane__controls">
        <Input
          theme="search"
          placeholder="Quick Search"
          value={search}
          onChange={(value) => setSearch(value)}
        />
      </div>
      <div
        className="add-slide-pane__content mac-scrollbar"
        style={{ '--mac-scrollbar-bk': '#fafafa' }}
      >
        {Object.values(CATEGORIES).map((category) => (
          <>
            <p className="add-slide-pane__category">{category}</p>
            <div key={category} className="add-slide-pane__slides">
              {AVAILABLE_SLIDES.filter((slide) => slide.category === category)
                .filter(searchSlide(search))
                .map((slide) => (
                  <Slide slide={slide} handleAddSlide={handleAddSlide(slide)} />
                ))}
            </div>
          </>
        ))}
      </div>
    </div>
  )
}

export default AddSlidePane
